module.exports = __webpack_public_path__ + "static/media/20220418-1.f449c2ca.png";